import React, { useEffect, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import ButtonRound from '../../ButtonRound';
import styles from './Modal.scss';
import { IPropertyWizardInput } from '../NewPropertyWizard';
import JsonApiRequest, { IContact } from '../../../utils/JsonApiRequest';
import useUser from '../../../stores/useUser';
import Owner from '../../../utils/Owner';
import cloneDeep from 'lodash/cloneDeep';

export interface ISuccessProps extends IPropertyWizardInput {
    moderationState?: string;
    values: any;
}

const Success: React.FC<React.PropsWithChildren<ISuccessProps>> = ({ step, data, onChange = () => { }, isLoading, moderationState, values }) => {
    const [user] = useUser();
    const [prevContact, setPrevContact] = useState({ field_address: {} } as IContact);
    const [nextContact, setNextContact] = useState(prevContact);
    const FormElement = 'form';
    const formProps = {
        onSubmit: (ev) => {
            handleSaveNumber(ev);
        },
    };

    useEffect(() => {
        Owner(user.id)
            .getContact()
            .then((data) => {
                setPrevContact(data);
                setNextContact(data);
            });
    }, []);

    const handleChange = (val: string) => {
        onChange(step.name, val);
    };

    const handleSaveNumber = (ev: React.FormEvent) => {
        ev.preventDefault();

        const currData = cloneDeep(nextContact);
        currData['phone'] = values.prefix + values.phone;
        setNextContact(currData);

        const newData = {
            data: {
                id: prevContact?.id,
                type: 'real_estate_contact--real_estate_contact' as const,
                attributes: {
                    phone: values.prefix + values.phone,
                },
            },
        };

        JsonApiRequest.patchRequest<IContact>(`/real_estate_contact/real_estate_contact/${prevContact?.id}`, newData)
            .then(() => {
                setPrevContact(nextContact);
            })
            .catch((e) => {
                console.log('Error', e);
            });
    };

    return (
        <div>
            <DialogContent dividers={false}>
                <FormElement {...formProps}>
                    <p><b>Deine Verifizierung war erfolgreich!</b></p>
                    <p>Du kannst deine Immobilie jetzt veröffentlichen.</p>
                    <div className={styles.publishButtons}>
                        <ButtonRound
                            onClick={() => {
                                handleChange(moderationState);
                            }}
                            disabled={isLoading}
                            type="submit"
                            size="extraLarge"
                            isLoading={(data.moderation_state === 'exclusively_published' && isLoading) || (data.moderation_state === 'published' && isLoading) || (data.moderation_state === 'draft' && isLoading)}
                        >
                            {moderationState === 'draft' ? 'Vorschau erstellen' : 'Immobilie veröffentlichen'}
                        </ButtonRound>
                    </div>
                </FormElement>
            </DialogContent>
        </div>
    )
}

export default Success;